import React, { ReactElement } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export default function WhyChooseUs(): ReactElement {
  const { t } = useTranslation();

  return (
    <div className="landing-page-wrapper">
      <section className="why-choose-us-section">
        <Container>
          <h1 className="wcus-title">
            {t("sme_why_choose_us_group_health_heading")}
            <span className="text-primary"> {t("solar_takaful_cover?")}</span>
            {/* {t("question_mark")} */}
          </h1>
          <div className="row gy-4">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="wcus-item">
                <img
                  src="/assets/img/hospitalStayHealth.svg"
                  alt="cashless-repairs"
                />
                <h2 className="wcus-label">{t("sme_why_choose_us_hospital_stay_heading")}</h2>
                <p className="wcus-desc">{t("sme_why_choose_us_hospital_stay_content")}</p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="wcus-item">
                <img
                  src="/assets/img/daycareHealth.png"
                  alt="better-rates"
                />
                <h2 className="wcus-label">{t("sehat_covverage_details_daycare_procedures_title")}</h2>
                <p className="wcus-desc">{t("covered_day_care_procedure_content")}</p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="wcus-item">
                <img
                  src="/assets/img/hospitalExpenseHealth.svg"
                  alt="assistance"
                />
                <h2 className="wcus-label"> {t("sme_why_choose_us_pre_post_hospitalization_heading")}</h2>
                <p className="wcus-desc">{t("sme_why_choose_us_pre_post_hospitalization_content")}</p>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
}
